<template>
    <div class="page-box">
      <Header/>
      <div class="mg-bottom-70 bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" title2="O2O线上线下一体化平台" title-row1="线上流量与线下体验有效结合，为商家提供更高" title-row2="效的运营和营销工具，形成" blue-text="线上线下一体化经营" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '166px'}" />
      </div>
      <!-- 经营痛点 -->
      <div class="mg-bottom-100">
        <ModuleTitle data-aos="fade-up" bg-color="#fff" title="经营痛点" :moduleTipsList="[{name: '线上线下分离导致运营成本高、库存滞销、获客难及渠道利用率低'}]" />
        <ModuleCenter>
            <div class="flex-box" data-aos="fade-up">
              <CardItem v-for="(item, index) in painList" :key="index" :item="item" :cardStyle="cardStyle"></CardItem>
            </div>
        </ModuleCenter>
      </div>
      <!-- O2O线上线下一体化打造门店核心竞争力 -->
      <div class="barrier-background pd-top-70 height-630 bg-color-0B4FD1" :style="{backgroundImage: 'url('+ bgBlue +')'}">
        <ModuleCenter >
          <div class="core-advantages">
            <ModuleTitle data-aos="fade-up" titleColor="#fff" title="O2O线上线下一体化打造门店核心竞争力" />
            <div class="flex-box" data-aos="fade-up" style="marign-top: 55px;">
              <div class="competitiveness-item" v-for="(item, index) in competitivenessList" :key="index">
                <img class="item-ilne-icon" :src="item.icon" alt="">
                <div class="competitiveness-item-content">
                  <div class="item-title">{{ item.name }}</div>
                  <div class="item-desc">{{ item.desc }}</div>
                  <div class="item-but">
                    <img class="item-but-icon" :src="SimpleCance" alt="">
                    <div>{{ item.butName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- O2O线上线下一体化业务模式 -->
      <div class="barrier-background pd-top-70 pd-bottom-100 height-auto">
        <ModuleCenter >
          <ModuleTitle data-aos="fade-up" title="O2O线上线下一体化业务模式" />
          <img data-aos="fade-up" style="width: 1200px;height: 500px;" class="goods-manage-mid-img" src="@/assets/product/digitalSystem/onlineOffline-banner-1.png" alt="" />
        </ModuleCenter>
      </div>
      <!-- 适用多种O2O商业形态 -->
      <div class="barrier-background height-auto">
        <ModuleCenter >
          <ModuleTitle data-aos="fade-up" title="适用多种O2O商业形态" :moduleTipsList="[{name: '支持合作加盟、同城社区、连锁直营三种O2O模式，帮助企业整合线下资源，融合线上平台，实现业务双线布局'}]" />
          <div class="flex-box" data-aos="fade-up">
            <div class="form-item">
                <img class="form-item-icon" :src="CancelImg" alt="">
                <div>
                  <div class="form-item-title">连锁直营模式</div>
                  <div class="form-item-desc">线上商城和线下多门店并重，通过门店员工导购完成营销互动，将分散到各门店会员集中到平台统一运营，由平台将流量分发到各个门店完成到店服务履约。</div>
                  <div>同类案例：</div>
                  <img class="form-item-show" src="@/assets/product/digitalSystem/form-1.png" alt="">
                </div>
            </div>
            <div class="form-item">
                <img class="form-item-png" src="@/assets/product/digitalSystem/form-2.png" alt="">
            </div>
            <div class="form-item">
                <img class="form-item-png" src="@/assets/product/digitalSystem/form-3.png" alt="">
            </div>
            <div class="form-item">
                <img class="form-item-icon" :src="CancelImg" alt="">
                <div>
                  <div class="form-item-title">同城或区域模式</div>
                  <div class="form-item-desc">平台汇聚区域多品类资源， 提供于线下多门店商家，根据用户所在的位置，按距离远近向用户展示最近的门店并提供服务。</div>
                  <div>同类案例：</div>
                  <img class="form-item-show" src="@/assets/product/digitalSystem/form-4.png" alt="">
                </div>
            </div>
            <div class="form-item">
                <img class="form-item-icon" :src="CancelImg" alt="">
                <div>
                  <div class="form-item-title">合作加盟模式</div>
                  <div class="form-item-desc">拥有多家合作加盟店，平台针对 B 端加盟门店及 C 端用户赋能,重构消费链接；通过线上宣传推广为线下合作加盟店带来流量，门店为用户提供相应的服务。</div>
                  <div>同类案例：</div>
                  <img class="form-item-show" src="@/assets/product/digitalSystem/form-5.png" alt="">
                </div>
            </div>
            <div class="form-item">
                <img class="form-item-png" src="@/assets/product/digitalSystem/form-6.png" alt="">
            </div>
          </div>
        </ModuleCenter>
      </div>
      <div class="barrier-background height-auto bg-F4F5FB pd-top-70 pd-bottom-40 bg-color-F4F5FB">
        <div class="mg-bottom-55">
          <ModuleTitle data-aos="fade-up" title="O2O线上线下一体化 互动体验交付全闭环" />
        </div>
        <ModuleCenter>
          <div class="closed-loop-item" data-aos="fade-up">
            <ModuleTitle title="线上全网触达" fontSize="26px" :moduleTipsList="[{name: '突破线下局限，构建线上全渠道销售体系，大数据驱动业务成长'}]" />
            <div class="flex-box">
              <CardItem v-for="(item, index) in closedLoopList.slice(0, 4)" :key="index" :item="item" :cardIconStyle="cardIconStyle" :card-style="closedLoopItemStyle"></CardItem>
            </div>
          </div>
          <div class="closed-loop-item" data-aos="fade-up">
            <ModuleTitle title="线下完美体验"   fontSize="26px"  :moduleTipsList="[{name: '发挥线下门店服务功能，弥补线上缺陷，提升消费体验'}]" />
            <div class="flex-box">
              <CardItem v-for="(item, index) in closedLoopList.slice(4, 8)" :key="index" :item="item" :cardIconStyle="cardIconStyle" :card-style="closedLoopItemStyle"></CardItem>
            </div>
          </div>
          <div class="closed-loop-item" data-aos="fade-up">
            <ModuleTitle title="物流及时服务"  fontSize="26px"  :moduleTipsList="[{name: '作为连接消费者和消费商品的纽带，满足个性化需求是新零售模式下的消费诉求'}]" />
            <div class="flex-box">
              <CardItem v-for="(item, index) in closedLoopList.slice(8, 12)" :key="index" :item="item" :cardIconStyle="cardIconStyle" :card-style="closedLoopItemStyle"></CardItem>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <Footer/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import Banner from '@/assets/product/digitalSystem/banner-3.jpg'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import IMBanner1 from '@/assets/product/digitalSystem/integration-module-banner-1.png'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
import SimpleCance from '@/assets/home/case_check.svg'
import bgBlue from '@/assets/product/digitalSystem/bg-blue-3.png'
export default {
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    IMBanner1,
    ModuleBgBlue
  },
   data() {
      return {
        OneStopBannerImg: OneStopBanner,
        SimpleCance: SimpleCance,
        CancelImg: Cancel,
        BannerImg: Banner,
        IMBanner1: IMBanner1,
        bgBlue: bgBlue,
        titleTipsList: [
          {
            name: '有效结合移动社交流量、门店流量、抢占线上线下市场混合连锁O2O一体化方案'
          },
          {
            name: '总部门店采销供应链、直营加盟统一管理，商城O2O，门店完整经营系统，帮助企业快速搭建新零售格局'
          },
          {
            name: '多门店O2O网上商城系统，全面打通零售业PC端、移动端、线下门店端，真正帮助零售商企形成前端和后端'
          }
        ],
        painList: [
          {
            icon: require("@/assets/product/svgIcon/pain-spot-8.svg"),
            name: '运营成本高',
            imgShow: false,
            descList: [
              '线上线下无法形成有效合力，各自运营成本较高',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-9.svg"),
            name: '库存滞销',
            imgShow: false,
            descList: [
              '独立的库存体系，导致门店备货量大，动销较慢，产生滞销库存',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-6.svg"),
            name: '获客困难',
            imgShow: false,
            descList: [
              '门店流量不足，获取成本较高，辐射用户范围有较大局限性',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-10.svg"),
            name: '渠道单一',
            imgShow: false,
            descList: [
              '无法高效的利用导购员的社交能力，在多渠道进行传播引流',
            ]
          }
        ],
        cardStyle: {
          width: '285px',
          height: '200px',
          padding: '30px 30px 0 30px'
        },
        competitivenessList: [
          {
            icon: require("@/assets/product/svgIcon/Unicom-1.svg"),
            name: '全渠道多终端覆盖',
            desc: '利用O2O商城系统搭建O2O电商平台，借助微信、小程序社交属性获取用户流量，融合直播、分销等热门电商玩法获得更多用户',
            butName: '快速引流获客'
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-6.svg"),
            name: '线上+线下无缝融合',
            desc: '线上推广引流，引导用户下单，线下门店提供上门自提等产品服务，升级用户体验，满足消费者更多个性化需求',
            butName: '全面提升用户体验'
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-2.svg"),
            name: '打破消费场景限制',
            desc: '不再局限于线下销售场景，门店拥有线上门店商城，灵活设置营业时间，消费者通过微信、小程序等渠道随时随地购物不受时间空间限制',
            butName: '24小时在线卖货'
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-4.svg"),
            name: '智能用户数据分析',
            desc: 'O2O电商平台智能数据统计分析：会员增长统计、消费者购物行为分析等多大维度数据分析为平台运营提供高精准度决策依据',
            butName: '精准化用户营销'
          },
        ],
        closedLoopList: [
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-1.png"),
            name: '社交化流量引擎',
            imgShow: false,
            descList: [
              '推广佣金、直播等社交化电商手段为线上商城引流，线上流量不在是问题'
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-2.png"),
            name: '全渠道销售',
            imgShow: false,
            descList: [
              '小程序或H5移动款快速朋友圈分享，不断传播品牌影响力，打造全渠道销售体系'
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-3.png"),
            name: '丰富的营销手段',
            imgShow: false,
            descList: [
              '拥有数十种营销手段，商城促销玩出新花样，增强会员黏性，提高复购率',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-4.png"),
            name: ' 大数据驱动',
            imgShow: false,
            descList: [
              '会员、商品、订单...掌握大数据，才能把握商城平台的运营要点，保证平台长期稳定发展',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-5.png"),
            name: ' 线下拓客',
            imgShow: false,
            descList: [
              '门店/商品二维码，将线下流量引导到线上，激活门店会员流量',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-6.png"),
            name: ' 订单自动分配',
            imgShow: false,
            descList: [
              '线上订单自动分配就近门店发货，降低快递成本，实现极速达',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-7.png"),
            name: ' 线上下单线下服务',
            imgShow: false,
            descList: [
              '线上订单到门店进行核销或者是门店提供服务，为门店引流',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-8.png"),
            name: ' 门店店员手持端',
            imgShow: false,
            descList: [
              '门店会员管理、卡券核销、收银、预约管理等移动导购管理',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-9.png"),
            name: ' LBS定位',
            imgShow: false,
            descList: [
              '通过LBS定位，为消费者匹配就近门店进行配送服务，提高配送效率',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-10.png"),
            name: ' 配送方式',
            imgShow: false,
            descList: [
              '配送方式的差异化：快递配送、门店配送、门店自提',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-11.png"),
            name: ' 配送时间',
            imgShow: false,
            descList: [
              '可设置配送时间，消费者下单时可选择合适时间进行配送',
            ]
          },
          {
            icon: require("@/assets/product/digitalSystem/closed-loop-12.png"),
            name: ' 配送范围',
            imgShow: false,
            descList: [
              '可对每家门店设置配送范围，匹配消费者的定位就近服务，降低配送成本',
            ]
          }
        ],
        closedLoopItemStyle: {
          width: '285px',
          height: '320px',
          padding: '30px 30px 0 30px',
          backgroundColor: '#FFF',
          marginBottom: '0px'
        },
        cardIconStyle: {
          width: '220px',
          height: '140px',
          marginBottom: '25px'
        }
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.barrier-background {
  width: 100%;
  min-width: 1200px;
  height: 810px;
  background-repeat: no-repeat;
  background-size: 1920px 100%;
  background-position: center;
}
.page-box {
  background-color: #fff;
}
.mg-bottom-70 {
  margin-bottom: 70px;
}
.mg-bottom-100 {
  margin-bottom: 100px;
}
.pd-top-70 {
  padding-top: 70px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
/* O2O线上线下一体化打造门店核心竞争力 */
.competitiveness-item {
  width: 585px;
  height: 170px;
  background: #FFFFFF;
  border-radius: 6px;
  overflow: hidden;
  padding: 30px 40px 0 40px;
  margin-bottom: 30px;
  display: flex;
}
.item-ilne-icon {
  width: 40px;
  height: 40px;
  margin-right: 15px;
}
.competitiveness-item-content {
  font-size: 14px;
  color: #595859;
  line-height: 20px;
  text-align: left;
}
.item-title {
  font-weight: bold;
  font-size: 18px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 12px;
}
.item-but {
  display: flex;
  align-items: center;
  margin-top: 18px;
  border-radius: 2px;
  border: 1px solid #DDE2E9;
  overflow: hidden;
  width: max-content;
  padding: 3px 10px;
}
.item-but-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.height-630 {
  height: 630px;
}
.height-auto {
  height: auto;
}
.pd-bottom-100 {
  padding-bottom: 100px;
}
.pd-bottom-40 {
  padding-bottom: 40px;
}
/* 适用多种O2O商业形态 */
.form-item {
  margin-bottom: 100px;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
  display: flex;
}
.form-item-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
  margin-top: 15px;
}
.form-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 20px;
}
.form-item-desc {
  margin-bottom: 30px;
  width: 500px;
}
.form-item-show {
  height: 50px;
}
.form-item-png {
  width: 610px;
  height: 250px;
}
/* O2O线上线下一体化 互动体验交付全闭环 */
.bg-F4F5FB {
  background-color: #F4F5FB;
}
.mg-bottom-55 {
  margin-bottom: 55px;
}
.closed-loop-item {
  background-color: #FFFFFF;
  padding: 30px 15px 0 15px;
  margin-bottom: 60px;
}
</style>
